var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.625C1.5 6.0337 2.13214 4.50758 3.25736 3.38236C4.38258 2.25714 5.9087 1.625 7.5 1.625C9.0913 1.625 10.6174 2.25714 11.7426 3.38236C12.8679 4.50758 13.5 6.0337 13.5 7.625C13.5 9.2163 12.8679 10.7424 11.7426 11.8676C10.6174 12.9929 9.0913 13.625 7.5 13.625C5.9087 13.625 4.38258 12.9929 3.25736 11.8676C2.13214 10.7424 1.5 9.2163 1.5 7.625ZM16.3073 16.121L12.951 12.7655C14.2674 11.3778 15.0009 9.53774 15 7.625C15 3.48275 11.6423 0.125 7.5 0.125C3.35775 0.125 0 3.48275 0 7.625C0 11.7673 3.35775 15.125 7.5 15.125C9.04637 15.1261 10.5548 14.6462 11.8162 13.7518L15.246 17.1823C15.5392 17.4748 16.014 17.4748 16.3073 17.1823C16.5998 16.889 16.5998 16.4142 16.3073 16.121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.0dedc8bc37c0454f525b3c1ccedbb9b3.svg";
export { ForwardRef as ReactComponent };